import { takeEvery, select, put } from "redux-saga/effects";

import {
  getStudentClubBookingIDList,
  getStudentDinnerBookingIDList,
  getStudentPaymentIDList,
  getFilteredShopItemIDList
} from "state/school_money/selectors";
import {
  STUDENT_CLUB_BOOKINGS_MARK_AS_SEEN,
  markClubBookingsAsSeen,
  STUDENT_DINNER_BOOKINGS_MARK_AS_SEEN,
  markDinnerBookingsAsSeen,
  STUDENT_PAYMENTS_MARK_AS_SEEN,
  markPaymentsAsSeen,
  STUDENT_SHOP_ITEMS_MARK_AS_SEEN,
  markShopItemsAsSeen
} from "state/school_money/actions";

/**
 * Pages dispatch actions whenever the visible student is changed
 *   to mark everything on that student's page as seen.
 * This saga converts the studentID into a list of entity IDs.
 */
export default function* markAsSeenSaga() {
  yield takeEvery(STUDENT_CLUB_BOOKINGS_MARK_AS_SEEN, clubBookings);
  yield takeEvery(STUDENT_DINNER_BOOKINGS_MARK_AS_SEEN, dinnerBookings);
  yield takeEvery(STUDENT_PAYMENTS_MARK_AS_SEEN, payments);
  yield takeEvery(STUDENT_SHOP_ITEMS_MARK_AS_SEEN, shopItems);
}

function* clubBookings(action) {
  const { studentID } = action.payload;
  const clubBookingIDList = yield select(getStudentClubBookingIDList, studentID);
  yield put(markClubBookingsAsSeen(clubBookingIDList));
}

function* dinnerBookings(action) {
  const { studentID } = action.payload;
  const dinnerBookingIDList = yield select(getStudentDinnerBookingIDList, studentID);
  yield put(markDinnerBookingsAsSeen(dinnerBookingIDList));
}

function* payments(action) {
  const { studentID } = action.payload;
  const paymentIDList = yield select(getStudentPaymentIDList, studentID);
  yield put(markPaymentsAsSeen(paymentIDList));
}

function* shopItems(action) {
  const { studentID } = action.payload;
  const shopItemIDList = yield select(getFilteredShopItemIDList, studentID);
  yield put(markShopItemsAsSeen(shopItemIDList));
}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/markAsSeenSaga.js